import { api } from "..";

export function createTagRequest(data) {
  return api.post("/v1/tag/create", data);
}

export function updateTagRequest({ id, data }) {
  return api.put(`/v1/tag/${id}`, data);
}

export function getTagRequest({ params }) {
  return api.get(`/v1/tag`, {
    params,
  });
}

export function getTagByIdRequest({ id, params }) {
  return api.get(`/v1/tag/${id}`, { params });
}
